// extracted by mini-css-extract-plugin
export default {"wrapper":"CoreValues_wrapper__Oikrx","core-values":"CoreValues_core-values__OmUom","icon":"CoreValues_icon__WOhKI","value":"CoreValues_value__kxykt","text":"CoreValues_text__r75d2"};